/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLifebuoy = createReactComponent("lifebuoy", "IconLifebuoy", [
  ["path", { d: "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-0" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }],
  ["path", { d: "M15 15l3.35 3.35", key: "svg-2" }],
  ["path", { d: "M9 15l-3.35 3.35", key: "svg-3" }],
  ["path", { d: "M5.65 5.65l3.35 3.35", key: "svg-4" }],
  ["path", { d: "M18.35 5.65l-3.35 3.35", key: "svg-5" }]
]);

export { IconLifebuoy as default };
//# sourceMappingURL=IconLifebuoy.js.map
